import React, { useState, useRef, useEffect } from "react";

import { HelperText, Icone } from "@componentes-mu/componentes-mu";

import styles from './styles.module.scss'

export type SelectOption = {
    value: string | number;
    label: string;
};

interface SelectProps {
    value: string | number | undefined;
    onChange: (value: string | number) => void;
    options: SelectOption[];
    placeholder?: string;
    disabled?: boolean;
    style?: React.CSSProperties
    error?: boolean;
    infoText?: string;
}

export const Select: React.FC<SelectProps> = ({
    value,
    onChange,
    options,
    placeholder = "Selecione uma opção...",
    disabled = false,
    style,
    error = false,
    infoText
}) => {
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedOption = options.find(opt => opt.value === value);

    return (
        <div>
            <div
                onClick={() => setOpen(o => !o)}
                className={`${styles.selectContainer} ${error ? styles.selectError : ''}`}
                ref={ref}
                style={style}
            >
                <div>
                    {selectedOption ?

                        <span className={styles.selectValue}>{selectedOption.label}</span>
                        :
                        <span className={styles.selectPlaceholder}>{placeholder}</span>
                    }
                </div>

                <Icone
                    className={styles.selectIcon}
                    nome={open ? "expand_less" : "expand_more"}
                    cor={disabled ? "#C1C1C1" : error ? "#D32F2F" : "#646363"}
                />

                {open && (
                    <div className={styles.selectMenuContainer}>
                        <div className={styles.selectMenu}>
                            <div className={styles.scroollbarContainer}>
                                {options.map(opt => (
                                    <div
                                        className={`${styles.selectMenuItem} ${opt.value === value ? styles.activeItem : ''}`}
                                        key={opt.value}
                                        onClick={() => {
                                            onChange(opt.value);
                                            setOpen(false);
                                        }}
                                        onMouseDown={() => {
                                            onChange(opt.value);
                                            setOpen(false);
                                        }}
                                    >
                                        {opt.label}
                                    </div>
                                ))}
                                {options.length === 0 && (
                                    <div style={{ padding: "10px 1rem", color: "#aaa" }}>Sem opções</div>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
            {error && infoText && (
                <HelperText
                    texto={infoText}
                    estado={error ? "error" : "regular"}
                />
            )}
        </div>

    );
};